// src/utils/constants/roles.js
export const USER_ROLES = {
    ADMIN: 'admin',
    MANAGER: 'manager',
    INVESTOR: 'investor'
  };
  
  export default USER_ROLES;